const isValidTelUrl = (str) => /^tel:[0-9-()+#*]+$/.test(str);
export {
  isValidTelUrl
};
//# sourceMappingURL=is-valid-te-url.js.map
